<template>
  <div class="home-container">
    <div :class="fixed?'fixed-search Top0':'fixed-search'">
      <div class="search">
        <el-input v-model="search"></el-input>
        <el-button @click="searchValue">搜索</el-button>
      </div>
    </div>
    <Header></Header>
    <div class="home-container-search-menu">
      <div class="center">
        <Search></Search>
        <nav-menu :lists="lists" :column="column" :open="open" @columnDataById="columnDataById"></nav-menu>
      </div>
    </div>
    <div class="home-container-main">
      <div class="view-container">
        <router-view :columnDetail="columnDetail" @openClassify="openClassify"></router-view>
      </div>
      <el-dialog
        v-if="advertisementImg"
        :visible.sync="centerDialogVisible"
        :close-on-click-modal="false"
        width="600px"
        :lock-scroll="false"
        center
      >
        <div class="dialog-container">
          <el-image :src="advertisementImg" fit="contain" @click="adLink(advertisementLink)"></el-image>
          <!-- <img :src="advertisementImg" alt @click="adLink(advertisementLink)" /> -->
        </div>
        <el-button icon="el-icon-close" type="text" @click="closeAd"></el-button>
      </el-dialog>
    </div>
    <Footer></Footer>
    <right-sidebar></right-sidebar>
  </div>
</template>

<script>
import { deleteXBReceivingGoodsAddressInfo } from "common/js/storage"
import Header from "base/xb-base/Header";
import Search from "base/xb-base/Search";
import NavMenu from "base/xb-base/NavMenu";
import Footer from "base/xb-base/Footer";
import RightSidebar from "base/xb-base/RightSidebar";
import XBHome from "models/xb/home.js";
import XBUser from "models/xb/user.js";
const xbHome = new XBHome();
const xbUser = new XBUser();
export default {
  components: {
    Header,
    Search,
    NavMenu,
    Footer,
    RightSidebar,
  },
  data() {
    return {
      search: "", // fiexed搜索框
      lists: [], // 分类数据
      centerDialogVisible: false, // 弹框
      advertisementImg: "", // 弹框广告图
      advertisementLink: "",
      column: [], // 栏目数据
      columnDetail: null,
      open: false, // 是否展开分类
      fixed: false, // 页面滚动出现悬浮搜索框
      token: "",
    };
  },
  // 加载广告
  beforeRouteUpdate(to, from, next) {
    if (from.redirectedFrom === "/") {
      xbUser.getXBAdvertisement().then((res) => {
        if(res.result) {
          this.advertisementImg = res.result
            ? res.result.adPath
            : "";
          this.advertisementLink = res.result
            ? res.result.adUrl
            : "";
          if (res.result.isUsed == 1) {
            this.centerDialogVisible = true;
          }
        }
      });
    }
    next();
  },
  created() {
    let isUsed = this.$route.params.isUsed
    this.advertisementImg = this.$route.params.adPath;
    this.advertisementLink = this.$route.params.adUrl;
    if (isUsed == 1) {
      this.centerDialogVisible = true;
    }
    this.getMenu(); // 侧边栏
    this.getColumnData(); // 头部导航
  },
  mounted() {
    window.addEventListener("scroll", () => {
      var H =
        document.body.scrollTop ||
        document.documentElement.scrollTop ||
        window.pageXOffset;
      if (H > 400) {
        this.fixed = true;
      } else {
        this.fixed = false;
      }
    });
  },
  methods: {
    // 搜索值
    searchValue() {
      deleteXBReceivingGoodsAddressInfo()
      this.$router.push({
        path: "/search",
        query: {
          value: this.search,
        },
      });
    },
    // 获取侧边栏数据
    getMenu() {
      xbHome.getXBMenu().then((res) => {
        let arr = [];
        res.result.map((value) => {
          let object = {};
          object.name = value.name;
          object.id = value.categoryId;
          object.children = [];
          value.children.map((val) => {
            let obj = {};
            obj.name = val.name;
            obj.id = val.categoryId;
            obj.children = [];
            val.children.map((v) => {
              let o = {};
              o.name = v.name;
              o.id = v.categoryId;
              obj.children.push(o);
            });
            object.children.push(obj);
          });
          arr.push(object);
        });
        this.lists = arr;
      });
    },
    // 广告链接
    adLink(path) {
      if (path) {
        window.open(path, "_blank");
      }
    },
    // 关闭广告弹窗
    closeAd() {
      this.centerDialogVisible = false;
    },
    // 获取栏目信息
    getColumnData() {
      xbHome.getXBColumn().then((res) => {
        this.column = res.result;
      });
    },
    // 根据id子组件传递给父组件数据
    columnDataById(data) {
      this.columnDetail = data;
    },
    // 是否展开分类
    openClassify(data) {
      this.open = data;
    },
    toProduct() {
      this.$router.push("/product");
    },
  },
};
</script>
<style lang='scss' scoped>
.home-container {
  width: 100%;
  font-family: "font-family:PingFangSC-Regular";
  .fixed-search {
    position: fixed;
    z-index: 10;
    width: 100%;
    top: -59px;
    padding: 8px 0;
    background: #fff;
    border-bottom: 3px solid rgba(223, 52, 69, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.2);
    .search {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .Top0 {
    top: 0px;
    transition: all 0.3s;
  }
  .home-container-search-menu {
    background: #fff;
    margin-bottom: 10px;
    /* padding-bottom: 5px; */
    border-bottom: 1px solid #e4e4e4;
    .center {
      width: 1200px;
      margin: 0 auto;
    }
  }
  .home-container-main {
    margin: 0 auto;
    width: 1200px;
    .view-container {
      min-height: 900px;
    }
  }
  .footer {
    background: #303132;
    .footer-conternt {
      width: 1200px;
      margin: 0 auto;
      .footer-top {
        min-height: 160px;
        padding-top: 18px;
        box-sizing: border-box;
        border-bottom: 1px solid #c9caca;
        display: flex;
        justify-content: space-evenly;
        > div {
          width: 192px;
          display: flex;
          flex-direction: column;
          align-items: center;
          p {
            font-size: 16px;
            color: rgba(255, 255, 255, 1);
            line-height: 22px;
            margin-bottom: 8px;
          }
          ul {
            li {
              font-size: 14px;
              color: rgba(255, 255, 255, 1);
              line-height: 20px;
              margin-bottom: 7px;
              text-align: center;
            }
          }
        }
      }
      .footer-bottom {
        height: 80px;
        box-sizing: border-box;
        padding-top: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        p {
          font-size: 14px;
          color: rgba(255, 255, 255, 1);
          line-height: 16px;
        }
      }
    }
  }
}
</style>
<style lang='scss'>
.home-container {
  .home-container-main {
    .el-dialog {
      top: 50% !important;
      border-radius: 4px;
      background-color: transparent;
      box-shadow: 0 0 0;
      overflow: hidden;
      margin-top: -200px !important;
      .el-dialog__header {
        display: none;
      }
      .el-dialog__body {
        padding: 0;
        /* height: 400px; */
        position: relative;
        .dialog-container {
          display: flex;
          align-items: center;
          height: 500px;
          overflow: hidden;
          .el-image {
            width: 100%;
            height: 100%;
            /* width: 600px; */
            cursor: pointer;
          }
        }
        .el-button {
          position: absolute;
          top: 0;
          right: 5px;
          font-size: 28px;
          width: 40px;
          /* color: #505050; */
          padding: 5px;
          font-weight: bold;
          .el-icon-close {
            background: #333;
            border-radius: 50%;
            color: #fff;
          }
        }
        .el-button:hover {
          color: #df3445;
        }
      }
    }
  }
  .fixed-search {
    .el-input {
      width: 400px;
      height: 36px;
      .el-input__inner {
        width: 400px;
        height: 36px;
        background: rgba(255, 255, 255, 1);
        border-radius: 2px 0px 0px 2px;
        border: 1px solid rgba(223, 52, 69, 1);
      }
    }
    .el-button {
      width: 80px;
      height: 36px;
      border: 1px solid rgba(223, 52, 69, 1);
      background: rgba(223, 52, 69, 1);
      border-radius: 0px 2px 2px 0px;
      color: rgba(245, 247, 250, 1);
      letter-spacing: 1px;
    }
  }
}
</style>
